<section class="flex-container {{widgetOrientation}}" [ngClass]="clpContents?.quoteWidget ? 'includeWidget' : 'noWidget'">

  <!-- For Horizontal or no widget layouts -->
  @if (widgetOrientation === 'horizontal' || !widgetOrientation) {
    <div class="flex-row-wrapper" [ngClass]="{'containsWidget': top}" #rowOne>
      @if (top) {
        <app-widget-wrapper [ngClass]="position === 'left' ? 'start' : 'end'"></app-widget-wrapper>
      }
      @for (content of clpContents?.top | mapToIterable; track content) {
        @if (content.val) {
          <div [style.width]="rowOneWidth + '%'" class="item-wrapper" [ngClass]="position !== 'left' ? 'start' : 'end'">
            <div class="flex-item" [innerHTML]="content.val | sanitizeHtml"></div>
          </div>
        }
      }
      @if (widgetOnHero && top) {
        <img id = "heroImage"  [src]="clpHeroImage" class="hero-img-clp" alt="altName" [class.nestled]="nestled" />
      }
    </div>
    <div class="flex-row-wrapper" [ngClass]="{'containsWidget': middle}" #rowTwo>
      @if (middle) {
        <app-widget-wrapper [ngClass]="position === 'left' ? 'start' : 'end'"></app-widget-wrapper>
      }
      @for (content of clpContents?.middle | mapToIterable; track content) {
        @if (content.val) {
          <div [style.width]="rowTwoWidth + '%'" class="item-wrapper" [ngClass]="position !== 'left' ? 'start' : 'end'">
            <div class="flex-item" [innerHTML]="content.val | sanitizeHtml"></div>
          </div>
        }
      }
      @if (widgetOnHero && middle) {
        <img id = "heroImage"  [src]="clpHeroImage" class="hero-img-clp" alt="altName" [class.nestled]="nestled" />
      }
    </div>
    <div class="flex-row-wrapper" [ngClass]="{'containsWidget': bottom}" #rowThree>
      @if (bottom) {
        <app-widget-wrapper [ngClass]="position === 'left' ? 'start' : 'end'"></app-widget-wrapper>
      }
      @for (content of clpContents?.bottom | mapToIterable; track content) {
        @if (content.val) {
          <div [style.width]="rowThreeWidth + '%'" class="item-wrapper" [ngClass]="position !== 'left' ? 'start' : 'end'" >
            <div class="flex-item" [innerHTML]="content.val | sanitizeHtml"></div>
          </div>
        }
      }
      @if (widgetOnHero && bottom) {
        <img id = "heroImage"  [src]="clpHeroImage" class="hero-img-clp" alt="altName" [class.nestled]="nestled" />
      }
    </div>
  }


  <!-- For Vertical -->
  @if (widgetOrientation === 'vertical') {
    <div class="flex-row-wrapper {{position}}" [ngClass]="{'containsWidget': top}" #rowOne>
      @if (top) {
        <app-widget-wrapper [ngClass]="position"></app-widget-wrapper>
      }
      @for (content of clpContents?.top | mapToIterable; track content) {
        @if (content.val) {
          <div [style.width]="rowOneWidth + '%'" class="item-wrapper" [ngClass]="position !== 'left' ? 'start' : 'end'">
            <div class="flex-item" [innerHTML]="content.val | sanitizeHtml"></div>
          </div>
        }
      }
      @if (widgetOnHero && top) {
        <img id = "heroImage"  [src]="clpHeroImage" class="hero-img-clp" alt="altName" [class.nestled]="nestled" />
      }
    </div>
    <div class="flex-row-wrapper {{position}}" [ngClass]="{'containsWidget': middle}" #rowTwo>
      @if (middle) {
        <app-widget-wrapper [ngClass]="position"></app-widget-wrapper>
      }
      @for (content of clpContents?.middle | mapToIterable; track content) {
        @if (content.val) {
          <div [style.width]="rowTwoWidth + '%'" class="item-wrapper" [ngClass]="position !== 'left' ? 'start' : 'end'">
            <div class="flex-item" [innerHTML]="content.val | sanitizeHtml"></div>
          </div>
        }
      }
      @if (widgetOnHero && middle) {
        <img id = "heroImage"  [src]="clpHeroImage" class="hero-img-clp" alt="altName" [class.nestled]="nestled" />
      }
    </div>
    <div class="flex-row-wrapper {{position}}" [ngClass]="{'containsWidget': bottom}" #rowThree>
      @if (bottom) {
        <app-widget-wrapper [ngClass]="position"></app-widget-wrapper>
      }
      @for (content of clpContents?.bottom | mapToIterable; track content) {
        @if (content.val) {
          <div [style.width]="rowThreeWidth + '%'" class="item-wrapper" [ngClass]="position !== 'left' ? 'start' : 'end'" >
            <div class="flex-item" [innerHTML]="content.val | sanitizeHtml"></div>
          </div>
        }
      }
      @if (widgetOnHero && bottom) {
        <img id = "heroImage"  [src]="clpHeroImage" class="hero-img-clp" alt="altName" [class.nestled]="nestled" />
      }
    </div>
  }
</section>
